export const DOCUMENTS = {
  USERS: 'users',
  JOBS: 'jobs',
  JOB_NOTIFICATION: 'jobNotification',
  INTERVIEWS: 'interviews',
  ROUNDS: 'rounds',
  COMPANY_DOCUMENTS: 'companyDocuments',
  COMPANY_ROUNDS: 'companyRounds',
  AUDITOR_SLOTS: 'auditorSlots',
  FEEDBACK: 'feedback',
  COMPANY_STATS: 'companyStats',
  USER_STATS: 'userStats',
  RESUME: 'resume'
};
